// extracted by mini-css-extract-plugin
module.exports = {"menuList":"LogoMenu_menuList__2Dblj","item":"LogoMenu_item__3DRLj","active":"LogoMenu_active__1DJmU"};